import axios from "axios";

const ALERTS_URL = `${import.meta.env.VITE_API_BASE_URL}/alerts`;
const DISMISSED_ALERTS_KEY = "mgis:dismissedAlerts";

function getSeverityAsString(severityNumber) {
  let severity = "info";
  if (severityNumber >= 10) {
    severity = "error";
  } else if (severityNumber >= 5) {
    severity = "warning";
  }
  return severity;
}

function getTodayAsIsoDate() {
  const date = new Date();

  // Build upd a date like: 2026-01-09 tied to the current time zone.
  // (using toIsoString() would give GMT's date)
  const year = date.getFullYear();
  // Months are 0-indexed in JS, so we add 1
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const day = String(date.getDate()).padStart(2, "0");

  return `${year}-${month}-${day}`;
}

function getStorageObject(key) {
  const stringValue = localStorage.getItem(key);
  return JSON.parse(stringValue);
}

function setStorageObject(key, value) {
  const stringValue = JSON.stringify(value);
  localStorage.setItem(key, stringValue);
}

function getAlertKey(alert) {
  return `${alert.start_date}:${alert.message}`;
}

function getDismissedAlerts() {
  return getStorageObject(DISMISSED_ALERTS_KEY) || [];
}

function setDismissedAlerts(dismissedAlerts) {
  setStorageObject(DISMISSED_ALERTS_KEY, dismissedAlerts);
}

function isAlertDismissed(findAlert) {
  const findAlertKey = getAlertKey(findAlert);
  return getDismissedAlerts().some(
    (alert) => getAlertKey(alert) === findAlertKey,
  );
}

function pruneDismissedAlerts(currentAlerts) {
  const dismissedAlerts = getDismissedAlerts();
  const prunedDismissedAlerts = dismissedAlerts.filter((dismissedAlert) => {
    const dismissedAlertKey = getAlertKey(dismissedAlert);
    return currentAlerts.find(
      (currentAlert) => getAlertKey(currentAlert) === dismissedAlertKey,
    );
  });
  setDismissedAlerts(prunedDismissedAlerts);
}

export function noteDismissedAlert(dismissedAlert) {
  let dismissedAlerts = getDismissedAlerts();
  const dismissedAlertKey = getAlertKey(dismissedAlert);
  dismissedAlerts = dismissedAlerts.filter(
    (alert) => getAlertKey(alert) !== dismissedAlertKey,
  );
  dismissedAlerts = [dismissedAlert, ...dismissedAlerts];
  setDismissedAlerts(dismissedAlerts);
}

export async function getUndismissedAlerts() {
  try {
    const response = await axios.get(ALERTS_URL);
    const currentAlerts = response.data.alerts;

    currentAlerts.forEach((alert) => {
      alert.severity = getSeverityAsString(alert.severity);
    });

    pruneDismissedAlerts(currentAlerts);

    const today = getTodayAsIsoDate();
    const activeAlerts = currentAlerts.filter(
      (alert) => alert.start_date <= today && today <= alert.end_date,
    );

    return activeAlerts.filter((alert) => !isAlertDismissed(alert));
  } catch (error) {
    console.log("Error getting alerts", error);
    return [];
  }
}
